"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrlFromExclusiveSearch = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var searchQueryToUrl_1 = require("@/transformers/searchQueryToUrl");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var searchTypeToUnit_1 = require("@/pages/exclusive/transformers/searchTypeToUnit");
exports.buildUrlFromExclusiveSearch = function (lang, searchType, priceMin, priceMax, keyword) {
    var searchTypeStr = searchType === SfilterTypeGroup_1.SfilterType.RENT ? 'rent' : 'buy';
    var keywordStr = keyword.trim() ? format_1.default.normalize(keyword.split(' | ')[0]) + "-keyword" : '';
    var unit = lang === 'en' ? searchTypeToUnit_1.searchTypeToUnit(searchType, true) : 10000;
    var priceMinFull = priceMin * unit;
    var priceMaxFull = priceMax * unit;
    var priceStr = priceMinFull || priceMaxFull ? searchQueryToUrl_1.buildPrice(priceMin, priceMax, SfilterPriceGroup_1.SfilterCurrency.HKD) : '';
    var url = [
        lang,
        'property-search',
        searchTypeStr,
        keywordStr,
        priceStr,
    ].filter(function (it) { return it; }).join('/');
    return "/" + url;
};
